export default __webpack_public_path__ + "static/media/2.bdb66426.jpg";